import React from 'react';
import Slider from './Slider';

const SliderSection = () => {
	return (
		<React.Fragment>
			<Slider />
		</React.Fragment>
	);
};

export default SliderSection;
